import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Delete, Edit, MoreHoriz } from '@mui/icons-material';
import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';

import styles from './OrganizationCard.module.scss';

export default function ClusterCard(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditItemClick = () => {
    setAnchorEl(null);
    navigate(`/dashboard/organizations/${props.data.id}/edit`);
  };

  const handleDeleteItemClick = () => {
    setAnchorEl(null);
    props.onDelete({
      entityType: 'organization',
      entityName: props.data.name,
      entityId: props.data.id
    });
  };

  return (
    <Box className={styles.card}>
      <Box className={styles.cardTitle}>{props.data.name}</Box>
      <Box className={styles.cardDescription} style={{ paddingBottom: 15 }}>
        {props.data.description || 'No description'}
      </Box>
      <Box className={styles.cardFooter} style={{ paddingTop: 20 }}>
        <Box className={styles.cardFooterItem}>
          <Button className={styles.button} onClick={handleEditItemClick}>
            Manage
          </Button>
          <Button className={styles.buttonSquare} onClick={handleClick}>
            <MoreHoriz style={{ color: '#343434' }} />
          </Button>
        </Box>
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem className={styles.menuItem} onClick={handleEditItemClick}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText className={styles.menuItemLabel}>Edit</ListItemText>
        </MenuItem>
        <MenuItem className={styles.menuItem} onClick={handleDeleteItemClick}>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText className={styles.menuItemLabel}>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}
